module.exports = __webpack_public_path__ + "img/ag.3a792a3b.svg";